<template>
  <div>
    <div v-if="this.$store.state.device.isDesktop">
      <navbarTop></navbarTop>
      <sideBar></sideBar>
      <div class="desktop_container">
        <div>
          <h5 style="text-align: left"><b>{{ $t('pages.Menu.Support') }}</b></h5>
          <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">
        </div>
        <p style="color: #2B2D42;" align="left">{{ $t('pages.Support.text') }}</p>
        <div class="divTextArea_desktop">
          <textarea class="textarea_desktop" maxlength="3000" :placeholder="$t('pages.Support.placeholder')" v-model="message"></textarea>
          <div style="text-align: right;margin-top: 5%; display: inline-block">
            <b-button class="btnNext" v-on:click="sendSupportEmail">{{ $t('pages.Support.btnSubmmit') }}</b-button>
          </div>
        </div>

        <b-modal id="modal" scrollable centered no-stacking hide-footer hide-header>
          <div style="text-align: center">
            <p style="color: #2B2B2B; font-size: 3vh;">{{ $t('pages.Support.confirmTitle1') }}</p>
            <i :style="{'font-size': '25vh', 'margin-top': '5%', 'margin-bottom': '10%', 'color': this.$store.state.device.color}" class="far fa-paper-plane"></i>
            <p align="left" style="padding-left: 16px;"><b>{{ $t('pages.Support.confirmTitle2') }}</b></p>
            <p align="left" style="padding-left: 16px;"><b>{{ $t('pages.Support.confirmTitle3') }}</b></p>
          </div>
        </b-modal>

      </div>
    </div>
    <div style="width: 100%; height: 100%;" v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <navbarBottom></navbarBottom>
      <div style="padding: 80px 0 50px">
        <p style="color: #2B2D42; margin: 0; padding: 16px;" align="left">{{ $t('pages.Support.text') }}</p>
        <div class="divTextArea">
          <textarea class="textarea" maxlength="3000" :placeholder="$t('pages.Support.placeholder')" v-model="message"></textarea>
          <b-button v-on:click="sendSupportEmail" class="btnSend" :style="{'background-color': this.$store.state.device.color+'!important'}">
            {{ $t('pages.Support.btnSubmmit') }}
          </b-button>
        </div>
        <div v-if="divEmailSent" class="divEmailSent">
          <a v-on:click="hideDivEmailSent" style="width: 100%; height: 10%;"><div style="width: 100%; height: 10%;"><i :style="{'float': 'right', 'padding-right': '5%', 'padding-top': '5%', 'font-size': '125%', 'color': this.$store.state.device.color}" class="fas fa-chevron-down"></i></div></a>
          <p style="color: #2B2B2B; font-size: 3vh;">{{ $t('pages.Support.confirmTitle1') }}</p>
          <i :style="{'font-size': '25vh', 'margin-top': '5%', 'margin-bottom': '10%', 'color': this.$store.state.device.color}" class="far fa-paper-plane"></i>
          <p align="left" style="padding-left: 16px;"><b>{{ $t('pages.Support.confirmTitle2') }}</b></p>
          <p align="left" style="padding-left: 16px;"><b>{{ $t('pages.Support.confirmTitle3') }}</b></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar";
  import { BModal } from 'bootstrap-vue'
  import {sendSupportEmail} from "../api/Auth/apiAuth";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "suporte",
    data() {
      return {
        divEmailSent: false,
        message: ''
      };
    },
    components: {NavbarTop, navbarBottom, sideBar, BModal},
    methods: {
      sendSupportEmail: function () {
        let spinner = this.$loading.open();
        let data = {};
        data.email = localStorage.getItem('email');
        data.message = this.message;
        if(data.message.length>=10){
          sendSupportEmail(data)
                  .then((response) => {
                    spinner.close();
                    this.$toast.open('Mensagem Enviada');
                    this.divEmailSent = true;
                  })
                  .catch(error => {
                    spinner.close();
                    if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                    if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                    else{
                      let response_error = error.response.data;
                      this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                    }
                  });
        }else {
          spinner.close();
          if(this.$i18n.locale()=='pt') {
            this.$toast.open({message:  pt.pages.Support.textAlertMessage,
              duration: 4000,
              type: 'is-danger'});
          }else if(this.$i18n.locale()=='en') {
            this.$toast.open({message: en.pages.Support.textAlertMessage,
              duration: 4000,
              type: 'is-danger'});
          }
        }
      },
      hideDivEmailSent: function () {
        this.message = '';
        this.divEmailSent = false;
      }
    }
  };
</script>

<style scoped>
  .divEmailSent {
    width: 100%;
    height: 70vh;
    bottom: 0;
    margin-bottom: 10%;
    margin-top: 25%;
    background-color: #ffffff;
    z-index: 900;
    position: absolute;
    border-radius: 32px;
    box-shadow: 0px -3px 3px #00000029;
  }
  .divTextArea {
    padding: 16px;
    width: 100%;
    height: 40vh;
    margin-top: 10vh;
  }
  .divTextArea_desktop {
    width: 100%;
    height: 40vh;
    margin-top: 5vh;
  }
  .textarea {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #B2B2B2;
    background-color: #f8f8f8;
    resize: none;
    padding-left: 5%;
    padding-top: 3%;
    color: #8e8e8e;
  }
  .textarea_desktop {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #B2B2B2;
    background-color: #f8f8f8;
    resize: none;
    padding-left: 1.5%;
    padding-top: 1%;
    color: #8e8e8e;
  }
  .btnSend {
    padding: 14px;
    width: 100%;
    border-radius: 32px !important;
    color: white !important;
    border: none;
    letter-spacing: 0.85px !important;
    margin-top: 5% !important;
  }
  @media (max-width: 1200px) {
    .btnNext {
      padding: 14px;
      padding-right: 50px;
      padding-left: 50px;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 50px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      text-align: center;
      position: fixed;
      bottom: 5vh;
      right: 3%;
      font-size: 125%;
    }
  }
  @media (min-width: 1200px) {
    .btnNext {
      padding: 14px;
      padding-right: 50px;
      padding-left: 50px;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 50px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      text-align: center;
      position: fixed;
      bottom: 5vh;
      right: 3%;
      font-size: 125%;
    }
  }

</style>
